import React from 'react'

import { TabsContext } from '../../../components/tabs/TabsContext'
import { Text } from '../../../components/presentation/Text'
import ForgotPasswordForm from './ForgotPasswordForm'
import ForgotPasswordSuccessMessage from './ForgotPasswordSuccessMessage'
import LoginForm from './LoginForm'
import LoginTemplate from '../_template/LoginTemplate'
import Panel from '../../../components/structure/Panel'
import TabsContent from '../../../components/tabs/TabsContent'
import ViewSwitcher from './ViewSwitcher'
import { COLORS } from '@btime/constants'
import { useUnloggedReason } from '../../../utils/session/unloggedReasons'
import LoginFormInternal from './LoginFormInternal'

const WarnMessage = () => {
  const message = useUnloggedReason()
  if (!message) return false
  return (
    <Panel bgColor={COLORS.red} smallPadding noMargin noShadow>
      <Text size="xsmall" color={COLORS.white} bold align="center">
        {message}
      </Text>
    </Panel>
  )
}

const tabs = [
  { name: 'login', Component: LoginForm },
  { name: 'forgotPassword', Component: ForgotPasswordForm },
  { name: 'success', Component: ForgotPasswordSuccessMessage }
]

const LoginPage = () => {
  return (
    <TabsContext options={tabs}>
      <LoginTemplate footer={<ViewSwitcher />}>
        <WarnMessage />
        <TabsContent />
      </LoginTemplate>
    </TabsContext>
  )
}

export default LoginPage
